/* eslint-disable react/jsx-no-constructed-context-values */
import React, { ReactNode, useContext, useState, useEffect } from 'react';
import { ICompanyClientViewModel } from 'viewModels';
import { CompanyController } from '../controller/CompanyController';
import { useAuth } from './auth';

type CompanyContextProps = {
  children: ReactNode;
};
interface IInitialValues {
  company: ICompanyClientViewModel[];
  setCompany: (value: ICompanyClientViewModel[]) => void;
}
const CompanyContext = React.createContext({} as IInitialValues);

const CompanyProvider = ({ children }: CompanyContextProps) => {
  const { tokenIsValid } = useAuth();
  const [company, setCompany] = useState<ICompanyClientViewModel[]>([]);

  useEffect(() => {
    if (!tokenIsValid) return;
    CompanyController.getClients().then(setCompany)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CompanyContext.Provider
      value={{
        company,
        setCompany,
      }}>
      {children}
    </CompanyContext.Provider>
  );
};
export const useCompany = () => useContext(CompanyContext);
export default CompanyProvider;
